// Bridge: lets non-module custom scripts (Vue customizer, colop, docband, grid)
// drive Horizon 4.0.0's section-rendering cart. They can't `import` @shopify/events
// (they load as plain <script>), so this module exposes a global that dispatches a
// proper CartLinesUpdateEvent — which makes cart-items-component morph the drawer
// and cart-drawer.js auto-open it.
import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Notify the theme that the cart changed so the <theme-drawer> cart morphs + opens.
 * @param {object} opts
 * @param {'add'|'remove'} [opts.action='add']
 * @param {Array<{merchandiseId: string, quantity: number}>} [opts.lines]
 * @param {Record<string,string>} [opts.sections] - section HTML from /cart/add.js (keyed by section id)
 */
window.dispatchCartLinesUpdate = function ({ action = 'add', lines = [], sections } = {}) {
  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action,
      context: 'customizer',
      lines,
      promise: deferred.promise,
    })
  );

  // /cart/add.js returns only added lines, so fetch the full cart for listeners
  // (cart icon bubble, etc.). The drawer items morph from `sections`.
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) =>
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { source: 'vue-customizer', sections },
      })
    )
    .catch(() => deferred.resolve({ cart: null, detail: { source: 'vue-customizer', sections } }));
};
